import { useState, useEffect, useCallback } from "react";
import SchoolHeader from "../header";
import SchoolSidebar from "../sidebar";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import TeacherServices from "../../../services/TeacherServices";
import $ from "jquery";
import Swal from "sweetalert2";

const EditTeacher = () => {
  const navigate = useNavigate();

  const [params] = useSearchParams();
  const [info, setInfo] = useState([]);

  const teacher_id = params.get("teacher_id");

  useEffect(() => {
    const fetchUser = async () => {
      const response = await TeacherServices.getTeacher(teacher_id);

      setInfo({
        id: response._id,
        name: response.name,
        email: response.email,
        address: response.address?.split(",")[0].trim() || "",
        city: response.address?.split(",")[1].trim() || "",
        state: response.address?.split(",")[2].trim() || "",
        zipCode: response.address?.split(",")[3].trim() || "",
      });
    };

    fetchUser();
  }, []);

  const handleEditSubmit = async () => {
    const newTeacher = await TeacherServices.updateTeacher(info);

    if (newTeacher) {
      Swal.fire({
        title: "Success!",
        text: "Teacher Edit successful !",
        icon: "success",
        confirmButtonText: "OK",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate(-1);
        }
      });
    }
  };

  return (
    <>
      -{/* Main Wrapper */}
      <div className="main-wrapper">
        {/* Header */}
        <SchoolHeader activeMenu={"Dashboard"} />
        {/* /Header */}
        {/* Breadcrumb */}
        <div className="breadcrumb-bar breadcrumb-bar-info">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-12">
                <div className="breadcrumb-list">
                  <h2 className="breadcrumb-title">Edit Teacher Information</h2>
                  <nav aria-label="breadcrumb" className="page-breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/school-dashboard">Home</Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        Dashboard
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Breadcrumb */}
        {/* Page Content */}
        <div className="page-content">
          <div className="container">
            <div className="row">
              {/* sidebar */}
              <SchoolSidebar />
              {/* /Sidebar */}
              {/* School Dashboard */}
              <div className="col-xl-9 col-lg-9">
                {/* Dashboard Grid */}
                <div>
                  <div className="input-block">
                    <label className="form-control-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={info.name}
                      onChange={(e) =>
                        setInfo((prev) => ({ ...prev, name: e.target.value }))
                      }
                      required
                    />
                  </div>
                  <div className="input-block">
                    <label className="form-control-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      value={info.email}
                      onChange={(e) =>
                        setInfo((prev) => ({ ...prev, email: e.target.value }))
                      }
                      required
                    />
                  </div>
                  <div className="input-block">
                    <label className="form-control-label">Address</label>
                    <input
                      type="text"
                      className="form-control"
                      value={info.address}
                      onChange={(e) =>
                        setInfo((prev) => ({
                          ...prev,
                          address: e.target.value,
                        }))
                      }
                      required
                    />
                  </div>
                  <div className="input-block">
                    <label className="form-control-label">City</label>
                    <input
                      type="text"
                      className="form-control"
                      value={info.city}
                      onChange={(e) =>
                        setInfo((prev) => ({ ...prev, city: e.target.value }))
                      }
                      required
                    />
                  </div>
                  <div className="input-block">
                    <label className="form-control-label">State</label>
                    <input
                      type="text"
                      className="form-control"
                      value={info.state}
                      onChange={(e) =>
                        setInfo((prev) => ({ ...prev, state: e.target.value }))
                      }
                      required
                    />
                  </div>
                  <div className="input-block">
                    <label className="form-control-label">ZipCode</label>
                    <input
                      type="text"
                      className="form-control"
                      value={info.zipCode}
                      onChange={(e) =>
                        setInfo((prev) => ({
                          ...prev,
                          zipCode: e.target.value,
                        }))
                      }
                      required
                    />
                  </div>

                  <div className="d-grid">
                    <button
                      className="btn btn-start"
                      onClick={handleEditSubmit}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Content */}
        {/* Footer */}

        {/* /Footer */}
      </div>
      {/* /Main Wrapper */}
    </>
  );
};

export default EditTeacher;
